"use strict";exports.round=function(r,t){var n=Math.pow(10,t);return Math.round(r*n)/n};
//# sourceMappingURL=round.cjs.map
